import { Helper } from '../../js/helpers/Helper';

/**
 * SecondaryNav Class
 */
class SecondaryNav {

	/**
	 * Constructor
	 *
	 * @param {node} block
	 * @return {void}
	 */
	constructor( block ) {

		this.block = block;

		if ( ! this.block ) {

			return false;

		}
		this.responsiveBreaks = [];
		this.breakpoint = 1110; //1025;//768;
		this.body = document.body;
		this.header = document.querySelector( 'header' );

		this.yoast = this.block.querySelector( '.yoast-breadcrumbs' );
		this.buttonsWrapper = this.block.querySelector( '.wp-block-buttons' );

		this.allLinks = this.buttonsWrapper.querySelectorAll( 'a:link' );
		this.moreDropdown = this.block.querySelector( '.more-dropdown' );

		this.allDropdownLinks = this.moreDropdown.querySelectorAll( 'a:link' );

		this.more = this.block.querySelector( '.more' );

		this.mediaQuery = window.matchMedia( `(min-width:${ this.breakpoint }px)` );

		this.currentUrlHash = '';
		this.currentUrlHref = '';
		this.getCurrentUrlHash();

		this.prepereLinks( this.allLinks );

		this.addEvents( this.block );
		this.moveOutYoast();

	}

	/**
	 * Has Yoast
	 *
	 * @return {bool}
	 */
	hasYoast() {

		return this.yoast ? true : false;

	}

	/**
	 * Move out logo from the default wrapper
	 *
	 */
	moveOutYoast() {

		if ( this.hasYoast() ) {

			this.block.prepend( this.yoast );

		}

	}

	/**
	 * Has header
	 *
	 * @return {bool}
	 */
	hasHeader() {

		return this.header ? true : false;

	}

	/**
	 * Get Header Height
	 *
	 * @return {void}
	 */
	getHeaderHeight() {

		if ( this.hasHeader() ) {

			return this.header.offsetHeight;

		}

	}

	/**
	 * Get SecondaryNav Height
	 *
	 * @return {void}
	 */
	getSecondaryNavHeight() {

		return this.block.offsetHeight;

	}

	/**
	 * Get ScrollTo Height
	 *
	 * @return {void}
	 */
	getScrollToHeight() {

		return this.getSecondaryNavHeight() + this.getHeaderHeight();

	}

	/**
	 * Set top style
	 *
	 * @return {void}
	 */
	setTop() {

		if ( this.hasHeader() && this.block.style.top === '' ) {

			this.block.style.top = `${ this.getHeaderHeight() }px`;

		}

	}

	/**
	 * toggleDropdown
	 *
	 * @return {void}
	 */
	toggleDropdown() {

		if ( Helper.hasClass( this.more, 'js-dropdown-opened' ) ) {

			Helper.removeClassFromEl( this.more, 'js-dropdown-opened' )

		} else {

			Helper.addClassToEl( this.more, 'js-dropdown-opened' );

		}

		if ( Helper.hasClass( this.moreDropdown, 'js-more-dropdown--open' ) ) {

			Helper.removeClassFromEl( this.moreDropdown, 'js-more-dropdown--open' )

		} else {

			Helper.addClassToEl( this.moreDropdown, 'js-more-dropdown--open' );

		}

	}

	/**
	 * update top style
	 *
	 * @return {void}
	 */
	updateTop() {

		if ( this.hasHeader() ) {

			setTimeout( () => {

				this.block.style.top = `${ this.getHeaderHeight() }px`;

			}, 60 );

		}

	}

	/**
	 * closeDropdown
	 *
	 * @return {void}
	 */
	closeDropdown() {

		Helper.removeClassFromEl( this.more, 'js-dropdown-opened' )
		Helper.removeClassFromEl( this.moreDropdown, 'js-more-dropdown--open' )

	}

	/**
	 * addRemoveClickedHandler
	 *
	 * @return {void}
	 */
	addRemoveClickedHandler() {

		this.moreDropdown.addEventListener( 'click', this.clickedDropdownHandler )

	}

	/**
	 * updateTopBar
	 *
	 * @param {element} entry
	 * @return {void}
	 */
	updateTopBar( entry ) {

		this.closeDropdown();

		const gap = 40;
		const blockWidth = entry.contentRect.width;
		const leftCol = entry.target.querySelector( '.b-secondary-navigation__title' );
		const menuItems = entry.target.querySelectorAll( '.wp-block-button' );

		let availableWidth = blockWidth - gap;

		if ( leftCol ) {

			availableWidth -= leftCol.offsetWidth;

		}
		let prev;
		let prevWidth = 0;
		let allButtonsWidth = 0;

		const availableSpace = availableWidth - 14-14 - gap;

		menuItems.forEach( ( el ) => {

			if ( prev ) {

				prevWidth = prev.offsetWidth;

			}

			if ( allButtonsWidth + prevWidth > availableSpace ) {

				this.more.classList.add( 'js-more--show' );

				if ( this.buttonsWrapper.firstElementChild !== this.buttonsWrapper.lastElementChild ) {

					this.responsiveBreaks.push( allButtonsWidth + prevWidth );
					this.moreDropdown.prepend( this.buttonsWrapper.lastElementChild );
					allButtonsWidth = 0;

					menuItems.forEach( ( el2 ) => {

						allButtonsWidth += el2.offsetWidth + 2;

					}
					);

				}

			} else {

				if ( availableSpace > this.responsiveBreaks[ this.responsiveBreaks.length - 1 ] ) {

					if ( this.moreDropdown.firstElementChild ) {

						this.buttonsWrapper.appendChild( this.moreDropdown.firstElementChild );
						this.responsiveBreaks.pop(); // Move the item back to the visible list

					}

				}
				if ( this.responsiveBreaks.length < 1 ) {

					this.more.classList.remove( 'js-more--show' );

				}

			}
			allButtonsWidth += el.offsetWidth + 2;
			prev = el;

		} );

	}

	/**
	 * Add class if scrollTo
	 *
	 * @param {element} link
	 */
	addClassIfScrollTo = ( link ) => {

		const href = link.getAttribute( 'href' );

		if ( href.startsWith( '#' ) ) {

			const sectionEl = document.querySelector( href );
			if ( sectionEl !== null ) {

				const position = sectionEl.getBoundingClientRect();

				window.scrollTo( position.left, position.top + window.scrollY - this.getScrollToHeight() );

				link.classList.add( 'current' );

			}

		}

	}

	/**
	 * Check if element has class 'current'
	 *
	 * @param {element} el
	 * @return {boolean}
	 */
	hasCurrent = ( el ) => {

		return (
			el.classList.contains( 'current' )
		)

	}

	/**
	 * Toggle class
	 *
	 * @param {Array} btnsArr
	 */
	toggleMoreCurrent = ( btnsArr ) => {

		if ( btnsArr.some( this.hasCurrent ) ) {

			this.more.classList.add( 'js-more--current' );

		} else {

			this.more.classList.remove( 'js-more--current' );

		}

	}

	/**
	 * Check if element is in viewport
	 *
	 * @param {element} el
	 * @param {boolean} partiallyVisible
	 * @return {boolean}
	 */
	isInViewport = ( el, partiallyVisible = true ) => {

		const { top, left, bottom, right } = el.getBoundingClientRect();
		const { innerHeight, innerWidth } = window;
		return partiallyVisible
			? ( ( top > 0 && top < innerHeight ) ||
			( bottom > 0 && bottom < innerHeight ) ) &&
			( ( left > 0 && left < innerWidth ) || ( right > 0 && right < innerWidth ) )
			: top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;

	};

	/**
	 * Add class if box which link scrollTo is in viewport on scroll
	 *
	 * @param {element} link
	 */
	boxInViewportOnScroll = ( link ) => {

		const href = link.getAttribute( 'href' );

		if ( href.startsWith( '#' ) ) {

			const box = document.querySelector( href );
			const allMoreLinks = this.more.querySelectorAll( 'a:link' );
			const btnsArr = Array.prototype.slice.call( allMoreLinks );

			if ( box !== null ) {

				if ( this.isInViewport( box ) ) {

					link.classList.add( 'current' );

				} else {

					link.classList.remove( 'current' );

				}

				this.toggleMoreCurrent( btnsArr );

			}

		}

	}

	/**
	 * Add class 'current' if link's href = url
	 *
	 * @param {element} link
	 */
	addClassIfHref = ( link ) => {

		if ( typeof ( link ) === 'undefined' || link === null ) {

			return

		}

		link.classList.remove( 'current' );//current-url
		const href = link.getAttribute( 'href' );

		if ( typeof ( this.currentUrlHref ) !== 'undefined' ) {

			if ( href === this.currentUrlHref || this.currentUrlHref.includes( `${ href }page` ) ) {

				link.classList.add( 'current' );//current-url

			}

		}

	}

	/**
	 * Add class 'current' if url has hash and link's href = hash
	 *
	 * @param {element} link
	 */
	addClassIfHash = ( link ) => {

		if ( typeof ( link ) === 'undefined' || link === null ) {

			return

		}

		link.classList.remove( 'current' );//current-url
		const href = link.getAttribute( 'href' );

		if ( typeof ( this.currentUrlHash ) !== 'undefined' ) {

			if ( href !== '#' && href.startsWith( '#' ) && href === this.currentUrlHash ) {

				link.classList.add( 'current' );//current-url

			}

		}

	}

	/**
	 * Get Current Url Hash
	 */
	getCurrentUrlHash = () => {

		const currentUrl = window.location;
		this.currentUrlHref = currentUrl.href;

		if ( currentUrl.href.indexOf( '#' ) >= 0 ) {

			this.currentUrlHash = currentUrl.hash;

		}

	}

	/**
	 * Remove current class from all elements
	 *
	 * @param {elements} all All links
	 */
	removeCurrentClass = ( all ) => {

		all.forEach( ( item ) => {

			if ( item.classList.contains( 'current' ) ) {

				item.classList.remove( 'current' );

			}

		} )

	}

	/**
	 * prepereLinks
	 *
	 * @param {elements} allLinks All links
	 */
	prepereLinks( allLinks ) {

		allLinks.forEach( ( link ) => {

			if ( typeof ( link ) === 'undefined' || link === null ) {

				return

			}

			this.addClassIfHash( link );
			this.addClassIfHref( link );

			document.addEventListener( 'scroll', ( ) => {

				this.boxInViewportOnScroll( link );

			} )

		} )

	}

	/**
	 * clickedButonHandler
	 *
	 * @param {object} e
	 */
	clickedButonHandler = ( e ) => {

		this.closeDropdown();
		if ( e.target.matches( 'a.wp-block-button__link' ) ) {

			const href = e.target.getAttribute( 'href' );

			if ( href && href !== '#' && href.startsWith( '#' ) ) {

				e.preventDefault();
				this.removeCurrentClass( this.allLinks );
				this.addClassIfScrollTo( e.target );

			}

		}

	}

	/**
	 * clickedDropdownHandler
	 *
	 * @param {object} e
	 */
	clickedDropdownHandler = ( e ) => {

		if ( e.target.matches( 'a.wp-block-button__link' ) ) {

			const href = e.target.getAttribute( 'href' );

			if ( href !== '#' && href.startsWith( '#' ) ) {

				e.preventDefault();
				this.removeCurrentClass( this.allLinks );
				this.removeCurrentClass( this.allDropdownLinks );

				this.addClassIfScrollTo( e.target );

			}

		}

	}

	/**
	 * handleMediaQueryChange
	 *
	 * @param {object} e
	 */
	handleMediaQueryChange = ( e ) => {

		if ( e.matches ) {

			this.updateTop();

		} else {

			this.updateTop();

		}

	}

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {

		const ro = new ResizeObserver( ( entries ) => {

			for ( const entry of entries ) {

				this.updateTopBar( entry )

			}

		} );

		ro.observe( this.block );

		this.buttonsWrapper.addEventListener( 'click', this.clickedButonHandler )

		this.more.addEventListener( 'click', () => {

			this.toggleDropdown();

		} );

		if ( this.allDropdownLinks ) {

			this.addRemoveClickedHandler()

		}

		this.mediaQuery.addEventListener( 'change', this.handleMediaQueryChange );
		this.handleMediaQueryChange( this.mediaQuery );

	}

}

document.querySelectorAll( '.b-secondary-navigation' ).forEach( ( block ) => {

	new SecondaryNav( block );

} )
